import React, { useState, useEffect } from 'react';
import classes from './Loading.module.css';
import Social from '../UI/Social/Social';
// import Swipe from '../UI/Swipe/Swipe';
import img0 from '../../Assets/Memoji/0.png';
import img1 from '../../Assets/Memoji/1.png';
import img2 from '../../Assets/Memoji/2.png';
import img3 from '../../Assets/Memoji/3.png';
import img4 from '../../Assets/Memoji/4.png';
import img5 from '../../Assets/Memoji/5.png';
import img6 from '../../Assets/Memoji/6.png';
import img7 from '../../Assets/Memoji/7.png';
import img8 from '../../Assets/Memoji/8.png';
import img9 from '../../Assets/Memoji/9.png';
const imgArray = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9];

const Loading = () => {
  const [active, setActive] = useState(
    imgArray[Math.floor(Math.random() * imgArray.length)]
  );

  useEffect(() => {
    let flag = 0;
    let loadingInterval = setInterval(() => {
      if (flag > 16) {
        clearInterval(loadingInterval);
      }
      // console.log(Math.floor(Math.random() * imgArray.length));
      setActive(
        prevValue =>
          (prevValue = imgArray[Math.floor(Math.random() * imgArray.length)])
      );
      flag += 1;
    }, 200);
  }, []);

  const ImageComponent = () => {
    return <img className={classes.image} src={active} alt="img" />;
  };

  return (
    <div className={classes.loading}>
      {/* <Swipe direction="right" header="Hello"></Swipe>
      <Swipe direction="left" delay={1} header="Guys"></Swipe>
      <Swipe direction="down" delay={2} header="Thanks&nbsp;for"></Swipe>
      <Swipe direction="top" delay={3} header="Visiting!"></Swipe> */}
      {/* <Swipe direction="right" delay={2} header="Loading..!" /> */}
      {/* <Swipe direction="top" delay={0} header="Loading..!" /> */}
      {ImageComponent()}
      {/* <Swipe direction="down" delay={1} header="Loading..!" /> */}
      {/* <Swipe direction="left" delay={3} header="Loading..!" /> */}
      <h1 className={classes.loading_text}>
        <span>L</span>
        <span>O</span>
        <span>A</span>
        <span>D</span>
        <span>I</span>
        <span>N</span>
        <span>G</span>
        <span>.</span>
        <span>.</span>
        <span>.</span>
      </h1>
      {/* <h1 className={classes.loading_text}>Site will be live soon!</h1> */}
      {/* <Social width="50px" /> */}
    </div>
  );
};

export default Loading;
